import { createSlice } from '@reduxjs/toolkit';
const initialState = {};
const typingIndicatorStyleSlice = createSlice({
  name: 'typingIndicatorStyle',
  initialState,
  reducers: {
    setTypingIndicatorStyle: (state, action) => {
      const {
        threadId,
        senderId,
        style,
        shouldDisableUserInput
      } = action.payload;
      if (!state[threadId]) {
        state[threadId] = {};
      }
      state[threadId][senderId] = {
        style,
        shouldDisableUserInput
      };
    },
    clearTypingIndicatorStyle: (state, action) => {
      const {
        threadId,
        senderId
      } = action.payload;
      if (state[threadId]) {
        delete state[threadId][senderId];
      }
    }
  }
});
export const {
  setTypingIndicatorStyle,
  clearTypingIndicatorStyle
} = typingIndicatorStyleSlice.actions;
export default typingIndicatorStyleSlice.reducer;